import Immutable from 'immutable'
import * as types from '../constants/EventtickerActionTypes'

const initialState = Immutable.Map({
	eventlist: Immutable.OrderedSet(),
    events: Immutable.Map(),
    startts: null,
    loadingevents: false,
    listener: null,
    loaded_until: null,
    selected: null,
    search: Immutable.Map({
        searching: false,
        choose: null
    })
})

function addEvent(state, events){
    let list = state.get('eventlist').toList();

    if(typeof events !== 'undefined')
        for(var i = events.length - 1; i >= 0; i--){
            let event = events[i];
            list = list.unshift(event.id);
            state = state.setIn(['events', event.id], Immutable.fromJS(event));	
        }
    
    list = list.toOrderedSet();

	state = state.set('eventlist', list);

    addOeEvent(state, events);

    return state;
}

function addOeEvent(state, events){
    let selected = state.get('selected');

    if(selected === null)return state;

    var uid = selected.get('uid');
    var list = null;

    if(typeof events !== 'undefined')
        for(var i = events.length - 1; i >= 0; i--){
            let event = events[i];

            if(event.uid === uid){
                if(list === null)
                    list = state.getIn(['selected', 'eventlist']).toList();
                list = list.unshift(event.id);

                state = state.setIn(['selected', 'events', event.id], Immutable.fromJS(event));
            }
        }
    
    if(list === null)return state; //No relevant event updated
    
    list = list.toOrderedSet();

	state = state.setIn(['selected', 'eventlist'], list);
    return state;
}

function appendEvent(state, events){
    let list = state.get('eventlist');
    events.forEach((event) => {
        list = list.add(event.id);
        state = state.setIn(['events', event.id], Immutable.fromJS(event));	
    });

	state = state.set('eventlist', list);
    return state;
}

function startLoadingEvents(state){
    return state.set('loadingevents', true);
}

function doneLoadingEvents(state, timestamp){
    state = state.set('loaded_until', timestamp);
    return state.set('loadingevents', false);
}

function setListener(state, listener){
    return state.set('listener', listener)
}

function setStartDate(state, date){
    state = state.set('eventlist', initialState.eventlist);
    return state.set('startts', date);
}

function stopListening(state){
    return state.set('listener', null);
}

function startSelectOe(state, id, plusId){
    return state.set('selected', Immutable.Map({
        loading: true,
        eventlist: Immutable.OrderedSet(),
        events: Immutable.Map(),
        uid: id,
        'plus-id': plusId
    }));
}

function doneSelectOe(state, events){
    state = state.setIn(['selected', 'loading'], false);

    let list = state.getIn(['selected', 'eventlist']);
    events.forEach((event) => {
        list = list.add(event.id);
        state = state.setIn(['selected', 'events', event.id], Immutable.fromJS(event));	
    });

	state = state.setIn(['selected', 'eventlist'], list);
    
    return state;
}

function appendOeEvent(state, events){
    let list = state.getIn(['selected', 'eventlist']);
    events.forEach((event) => {
        list = list.add(event.id);
        state = state.setIn(['selected', 'events', event.id], Immutable.fromJS(event));	
    });

	state = state.setIn(['selected', 'eventlist'], list);
    return state;
    
}

function unselectOe(state){
    return state.set('selected', null);
}

function startSearch(state){
    return state.set('search', initialState.get('search').set('searching', true));
}

function doneSearch(state, hasResults, choose){
    state = state.setIn(['search', 'searching'], false);

    if(!hasResults)return state.setIn(['search', 'no-results'], true);
    if(choose === null)return state;

    return state.setIn(['search', 'choose'], Immutable.fromJS(choose));
}

function closeSearch(state){
    return state.set('search', initialState.get('search'));
}

export default function eventticker (state = initialState, action) {
  switch (action.type) {
  	case types.SET_START_DATE:
  		return setStartDate(state, action.date);
  	case types.START_LISTENING:
  		return setListener(state, action.listener);
    case types.STOP_LISTENING:
        stopListening(state);
    case types.ADD_EVENT:
  		return addEvent(state, action.events);
    case types.APPEND_EVENT:
  		return appendEvent(state, action.events);
    case types.START_LOADING_EVENTS:
  		return startLoadingEvents(state);
    case types.DONE_LOADING_EVENTS:
  		return doneLoadingEvents(state, action.timestamp);
    case types.START_SELECT_OE:
        return startSelectOe(state, action.id, action.plusId);
    case types.DONE_SELECT_OE:
        return doneSelectOe(state, action.events);
    case types.UNSELECT_OE:
        return unselectOe(state);
    case types.START_SEARCH:
        return startSearch(state);
    case types.DONE_SEARCH:
        return doneSearch(state, action.hasResults, action.choose);
    case types.CLOSE_SEARCH:
        return closeSearch(state);
    default:
      return state;
  }
}
